import React from 'react';

export const emailPrevalidation = function emailPrevalidation(
  value: string,
): React.ReactElement[] {
  const messageUiArray: React.ReactElement[] = [];
  if (value.match(/[\s\r\n\t\b\f]/)) {
    messageUiArray.push(
      <span className="fj-prevalidation" key="unrecognized-email-format">
        [Spaces not valid in email addresses.]
      </span>,
    );
  }

  if (value.length < 6 || value.length > 254) {
    messageUiArray.push(
      <span className="fj-prevalidation" key="email-length-incorrect">
        [Email character length must be at least 6 and no more than 254.]
      </span>,
    );
  }

  const atSignPosition = value.indexOf('@');

  // Check a user string exists with at least one character before a @
  if (atSignPosition < 1) {
    messageUiArray.push(
      <span className="fj-prevalidation" key="one-char-before-the-@">
        [Must have at least one @ and at least one character before the @.]
      </span>,
    );
  }

  const postAtSign = value.substring(atSignPosition + 1);
  const tldPeriodPosition = postAtSign.lastIndexOf('.');
  const numCharsTld = postAtSign.length - tldPeriodPosition - 1;

  // Check tld has at least 2 chars
  if (numCharsTld < 2) {
    messageUiArray.push(
      <span className="fj-prevalidation" key="tdl-must-be-two-chars">
        [The ending portion of a domain name is called a top-level domain and must have at least two
        characters (Example: .eu or .com).]
      </span>,
    );
  }

  const domain = postAtSign.substring(0, tldPeriodPosition);
  // Check that the domain has at least one char.
  if (domain.length < 1) {
    messageUiArray.push(
      <span className="fj-prevalidation" key="domains-and-subdomains-must-have-at-least-one-char">
        [Must be at least one character in the domain name and must also include a top-level domain
        such as .com or .jp (Example: my-email@.com is not valid).]
      </span>,
    );
  }

  // Dissalow a domain to start with a .
  if (domain[0] === '.') {
    messageUiArray.push(
      <span className="fj-prevalidation" key="cannot-begin-with-period">
        [Domains cannot begin with a period (Example: my-email@.flowjo.com is not valid).]
      </span>,
    );
  }

  // Don't allow periods to touch
  let lastPeriodPosition = -1;
  for (let i = 0; i < domain.length; i += 1) {
    const char = domain[i];
    if (char === '.') {
      if (lastPeriodPosition === i - 1) {
        // If we are here it is because this char and the last char are both periods which
        // is disallowed
        messageUiArray.push(
          <span className="fj-prevalidation" key="periods-cannot-touch-each-other">
            [Periods to right of @ cannot touch each other.]
          </span>,
        );
      }
      lastPeriodPosition = i;
    }
  }

  return messageUiArray;
};
